<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-50">
    <div class="max-w-md w-full space-y-8 p-8 bg-white rounded-lg shadow-md">
      <div class="text-center">
        <img class="mx-auto h-12 w-auto" src="https://www.google.com/images/branding/googlelogo/1x/googlelogo_color_272x92dp.png" alt="Google" />
        <h2 class="mt-6 text-3xl font-extrabold text-gray-900">Sign in to your account</h2>
      </div>

      <div class="mt-8 space-y-6">
        <!-- <div class="rounded-md shadow-sm space-y-4">
          <div>
            <label for="email" class="sr-only">Email address</label>
            <input
              id="email"
              name="email"
              type="email"
              autocomplete="email"
              required
              class="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
              placeholder="Email address"
            />
          </div>
          <div>
            <label for="password" class="sr-only">Password</label>
            <input
              id="password"
              name="password"
              type="password"
              autocomplete="current-password"
              required
              class="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
              placeholder="Password"
            />
          </div>
        </div>

        <div class="flex items-center justify-between">
          <div class="flex items-center">
            <input id="remember-me" name="remember-me" type="checkbox" class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
            <label for="remember-me" class="ml-2 block text-sm text-gray-900">Remember me</label>
          </div>

          <div class="text-sm">
            <a href="#" class="font-medium text-blue-600 hover:text-blue-500">Forgot your password?</a>
          </div>
        </div> -->

        <div>
          <button
            @click="loginWithGoogle"
            class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            Sign in with Google
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // import Cookies from 'js-cookie'

  // Cookies.remove('bowsystoken')

  export default {
    //     setup() {

    //       const loginWithGoogle = () => {
    // // loginWithGoogle() {
    //         // Redirect to backend Google OAuth endpoint
    //         // window.location.href = 'http://localhost:3000/auth/google'
    //         window.location.href = 'https://boyo.mn/auth/google'
    //       }

    //     }
    methods: {
      loginWithGoogle() {
        // Redirect to backend Google OAuth endpoint
        // window.location.href = 'http://localhost:3000/auth/google'

        window.location.href = 'https://boyo.mn/auth/google'
      },
    },
  }
</script>
<!-- <template>
  <div class="flex justify-center items-center h-screen bg-primary bg-slate-200">
    <div class="bg-[#FCFCF7] w-1/2 h-72 flex flex-col gap-6 justify-center items-center rounded-lg text-primary font-bold">
      <p class="text-2xl text-center">
        WELCOME TO
        <br />
        <span class="text-lg">BOWLLC NYBO SYSTEM</span>
      </p>

      <div id="buttonDiv"></div>
    </div>
  </div>
</template> -->

<!-- <script>
  import { useStore } from 'vuex'
  import { onMounted } from 'vue'
  import Cookies from 'js-cookie'

  export default {
    name: 'LoginPage',
    setup() {
      const store = useStore()

      const handleCredentialResponse = async (response) => {
        try {
          console.log('A1', response)
          const res = await store.dispatch('checkidToken', {
            idToken: response.credential,
          })
          if (res.data.statusCode == 200) {
            setTokenAndRedirect(res)
          } else {
            alert(res.data.message)
          }
        } catch (e) {
          console.error(e)
        }
      }

      const initializeGoogleSignIn = () => {
        window.google.accounts.id.initialize({
          client_id: '289671570944-hs1or1s6k8b32r6v3ge8gn58jdt1jb3r.apps.googleusercontent.com',
          callback: handleCredentialResponse,
        })
        window.google.accounts.id.renderButton(document.getElementById('buttonDiv'), { theme: 'outline', size: 'large' })
        window.google.accounts.id.prompt()
      }

      onMounted(() => {
        initializeGoogleSignIn()
      })

      const setTokenAndRedirect = async (res) => {
        const expirationDate = new Date()
        expirationDate.setTime(expirationDate.getTime() + 3 * 60 * 60 * 1000)
        Cookies.set('bowsystoken', res.data.token, {
          expires: expirationDate,
        })

        if (res.status) {
          await store.dispatch('bowsys/fetchRoute', {
            name: 'Home',
            icon: 'fa-home',
            path: '/bowsys',
          })

          window.location.href = '/bowsys'
        }
      }

      return {
        handleCredentialResponse,
        initializeGoogleSignIn,
      }
    },
  }
</script> -->
